export enum LanguageCode {
  Swedish,
  English,
}
